<template>
  <div class="nwx-snackbar" ref="snackbar">
    <div :class="getClassList">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NwxSnackbar',
    props: ['visible', 'type'],
    model: {
      prop: 'visible',
      event: 'snackbar:hide',
    },
    data() {
      return {
        el: null,
        timer: null,
      };
    },
    watch: {
      immediate: true,
      visible() {
        this.perform();
      },
    },
    computed: {
      getClassList() {
        let result = 'snackbar-cont';

        if (this.type === 'success') {
          result += ' snack-success';
        } else if (this.type === 'fail') {
          result += ' snack-fail';
        }

        return result;
      },
    },
    mounted() {
      this.el = this.$refs.snackbar;
      this.perform();
    },
    methods: {
      perform() {
        if (this.visible) {
          this.show();
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.hide();
          }, 6000);
        } else {
          this.hide();
        }
      },
      show() {
        this.el.style.opacity = '1';
        this.el.style.top = '-1px';
      },
      hide() {
        this.el.style.opacity = '0';
        this.el.style.top = '-85px';
        this.$emit('snackbar:hide', false);
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../assets/variables';

  .nwx-snackbar {
    width: 100%;
    text-align: center;
    pointer-events: none;
    position: fixed;
    top: -85px;
    left: 0;
    opacity: 0;
    z-index: 1000;
    transition: top .3s, opacity .3s;

    .snackbar-cont {
      max-width: 1127px;
      display: inline-block;
      background: @mainGray;
      color: #fff;
      font-size: 16px;
      line-height: 1.8;
      padding: 14px 30px;
      border-radius: 0 0 5px 5px;
      pointer-events: auto;

      &.snack-success {
        background: #0AB61B;
      }

      &.snack-fail {
        background: @mainRed;
      }
    }
  }
</style>
